const theme = {
  breakpoints: {
    // mobile: '480px',
    // tablet: '768px',
    smobile: "320px", // 작은사이즈 모바일
    mobile: "440px",
    tablet: "810px",
    desktop: "1024px",
    iphone: "1024px", // 아이폰도 모바일로 적용
  },
};

export default theme;
